import React from 'react'
import EmojiCollection from './EmojiCollection'

const Emoji = (props) => (
  <div
    className="emoji"
    onClick={(event) => {
      props.onClick(props.emoji)
    }}
  >
    <span className="emojiReference">A</span>
    <span className="emojiChar">{props.emoji}</span>
  </div>
)

const EmojiGroup = (props) => (
  <div
    className={`emojiGroup${props.selected ? ' emojiGroupSelected' : ''}`}
    onClick={(event) => {
      props.onClick(props.group)
    }}
  >
    {props.group}
  </div>
)

class EmojiPicker extends React.Component {
  constructor(props) {
    super(props)
    this.myRef = React.createRef()
    this.state = {
      selectedGroup: 'food',
    }
  }

  setSelectedGroup = (selectedGroup) => {
    this.setState({ selectedGroup })
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.onDocumentMouseDown)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.onDocumentMouseDown)
  }

  onDocumentMouseDown = (event) => {
    const node = this.myRef.current
    if (node && !node.contains(event.target)) {
      this.props.onClickOutside(event.target.className)
    }
  }

  onClickGroup = (group) => {
    this.setSelectedGroup(group)
  }

  render() {
    const { selectedGroup } = this.state
    const groups = Object.keys(EmojiCollection)
    const emojis = EmojiCollection[selectedGroup]
    return (
      <div className="emojiPicker" ref={this.myRef}>
        <div className="emojiPickerHandle" />
        <div className="emojiPickerBackground">
          <div className="emojiGroups">
            {groups.map((group) => (
              <EmojiGroup
                key={group}
                group={group}
                onClick={this.onClickGroup}
                selected={group === selectedGroup}
              />
            ))}
          </div>
          <div className="emojiPickerEmojis">
            {emojis.map((emoji, i) => (
              <Emoji key={i} emoji={emoji} onClick={this.props.onClickEmoji} />
            ))}
          </div>
        </div>
      </div>
    )
  }
}

export default EmojiPicker
